var infraestructuras = angular.module('infraestructuras');

infraestructuras.factory('infraestructurasService', ['$http', '__env', function infraestructurasService($http, __env) {

    var serviceUrl = __env.apiUrl;
    var infraestructurasUrl = 'categorias';
    var dañosUrl = 'damages';
    var dañosADIFUrl = 'damagesADIF';
    var informesUrl = 'informes';
    var dañoUrl = 'damage';
    var dañoADIFUrl = 'damageADIF';
    var chatboxUrl = 'ChatBox';



    function getTiposRed() {
        return $http.get(serviceUrl + '/infraestructuras/tiposred');
    }


    function getCategorias() {
        return $http.get(serviceUrl + infraestructurasUrl);
    }

    function getCategoria(idCategoria) {
        return $http.get(serviceUrl + infraestructurasUrl + '/' + idCategoria);
    }

    function getDatosGalibos() {
        return $http.get(serviceUrl + "galibos");
    }

    function getUltimaInspeccionPorTunel(idTunel) {
        return $http.get(serviceUrl + dañosUrl + "/tunel/" + idTunel);
    }

    function getUltimaInspeccionPorTunelADIF(idTunelADIF) {
        return $http.get(serviceUrl + dañosUrl + "/tunelADIF/" + idTunelADIF);
    }

    function getTodasLasInspecciones(idCategoria) {
        return $http.get(serviceUrl + '/infraestructuras/all/' + idCategoria);
    }

    function getInforme(idInspeccion) {
        return $http({
            url: serviceUrl + informesUrl + "/informeinspeccion/" + idInspeccion,
            method: 'post',
            responseType: 'blob',
            headers: { 'Content-Type': undefined }
        });
    }

    function getListado(idInspeccion) {
        return $http({
            url: serviceUrl + informesUrl + "/listadoinspeccion/" + idInspeccion,
            method: 'post',
            responseType: 'blob',
            headers: { 'Content-Type': undefined }
        });
    }


    function getGravedades() {
        //return $http.get(
        //    urlService + 'infraestructuras/gravedades'
        //);

        return $http.get(serviceUrl + infraestructurasUrl + "/gravedades");

    };


    function getDañosPorTipo(idInspeccion) {
        return $http.get(serviceUrl + dañosUrl + "/damagesportipo/" + idInspeccion);
    }

    function getDañosADIFPorTipo(idInspeccion) {
        return $http.get(serviceUrl + dañosADIFUrl + "/damagesportipo/" + idInspeccion);
    }

    function getDañosPorGravedad(idInspeccion) {
        return $http.get(serviceUrl + dañosUrl + "/damagesporgravedad/" + idInspeccion);
    }

    function getDañosADIFPorGravedad(idInspeccion) {
        return $http.get(serviceUrl + dañosADIFUrl + "/damagesporgravedad/" + idInspeccion);
    }


    // silvia para tuneles


    function getDañosPorGravedadTodosLosTuneles(id, usuario) {
        return $http({
            method: 'get',
            url: serviceUrl + '/infraestructuras/tuneles/damagesporgravedad/categoria/' + id,
            params:
            {
                'usuario': usuario
            }
        });
    }


    function getDañosPorGravedadTodosLosTunelesADIF(id, usuario) {
        return $http({
            method: 'get',
            url: serviceUrl + '/infraestructuras/tunelesADIF/damagesporgravedad/categoria/' + id,
            params:
            {
                'usuario': usuario
            }
        });
    }



    function getDañosPorElemento(idInspeccion) {
        return $http.get(serviceUrl + dañosUrl + "/damagesporelemento/" + idInspeccion);
    }

    function getDañosADIFPorElemento(idInspeccion) {
        return $http.get(serviceUrl + dañosADIFUrl + "/damagesporelemento/" + idInspeccion);
    }

    //function getDañosPorSeccion(idInspeccion, distSeccion) {
    //    return $http.get(serviceUrl + dañosUrl + "/damagesporseccion/" + idInspeccion + "/" + distSeccion);
    //}

    function getResumenPorSeccion(idInspeccion, distSeccion) {
        return $http.get(serviceUrl + dañosUrl + "/resumenporseccion/" + idInspeccion + "/" + distSeccion);
    }

    function getInfraestructurasADIFCategoria(id, usuario) {
        return $http({
            method: 'get',
            url: serviceUrl + 'infraestructuras/categoria/ADIF/' + id,
            params:
            {
                'usuario': usuario
            }
        });
    }


    function getPatologiasTunelesADIF(
        idsTuneles,
        gravedad,
        pagina,
        tamanoPagina
    ) {

        return $http({
            method: 'post',

            url:
                serviceUrl +
                'infraestructuras/tunelesADIF/patologias',

            params: {
                gravedad: gravedad || null,
                pagina: pagina || 1,
                tamanoPagina: tamanoPagina || 100
            },

            data: idsTuneles
        });
    }


    function getResumenTiposPatologiasTunelesADIF(idsTuneles) {

        return $http({
            method: 'post',

            url:
                serviceUrl +
                'infraestructuras/tunelesADIF/patologias/resumen-tipos',

            data: idsTuneles
        });
    }



    function getResumenElementosPatologiasTunelesADIF(idsTuneles) {

        return $http({
            method: 'post',

            url:
                serviceUrl +
                'infraestructuras/tunelesADIF/patologias/resumen-elementos',

            data: idsTuneles
        });
    }


    function getInfraestructurasNOADIFCategoria(id, usuario) {
        return $http({
            method: 'get',
            url: serviceUrl + 'infraestructuras/categoria/NOADIF/' + id,
            params:
            {
                'usuario': usuario
            }
        });
    }



    function getInfraestructuraPorGravedad(idCategoria) {
        return $http({
            method: 'get',
            url: serviceUrl + '/infraestructuras/infraestructurasporgravedad/' + idCategoria,
        });
    }


    // fin silvia para tuneles


    function getInfraestructura(id) {
        return $http.get(serviceUrl + '/infraestructuras/' + id);
    }

    function getTiposTunel() {
        return $http.get(serviceUrl + "tiposTunel");
    }


    function getTiposPresa() {
        return $http.get(serviceUrl + "tipoPresa");
    }

    function getformaPlanta() {
        return $http.get(serviceUrl + "tipoPresa" + '/formaPlanta/');
    }

    function getMaterialesPresa() {
        return $http.get(serviceUrl + "tipoPresa" + '/materiales/');
    }

    function getCategoriaPresa() {
        return $http.get(serviceUrl + "tipoPresa" + '/categoria/');
    }

    function getUsosPresa() {
        return $http.get(serviceUrl + "tipoPresa" + '/usos/');
    }


    function getObstaculos() {
        return $http.get(serviceUrl + "obstaculo");
    }

    function getObstaculos() {
        return $http.get(serviceUrl + "obstaculo");
    }

    function getNumDireccionesTunel() {
        return $http.get(serviceUrl + "numDireccionesTunel");
    }

    function getLongitudTunel() {
        return $http.get(serviceUrl + "longitudTunel");
    }

    function getMaterialesTunel() {
        return $http.get(serviceUrl + "materialTunel");
    }

    function getTipoVia() {
        return $http.get(serviceUrl + "tipoVia");
    }

    function getCirculacionPermitida() {
        return $http.get(serviceUrl + "circulacionPermitida");
    }

    function getTunel(idInfraestructura) {
        return $http.get(serviceUrl + "tuneles/" + idInfraestructura);
    }

    function guardarInventarioTunel(Id, tunel, COD_INT, propietarioId, entornoId, municipioId) {

        return $http({
            method: 'put',
            url: serviceUrl + 'tuneles/put/' + Id,
            params:
            {
                //'strTunel': JSON.stringify(tunel),
                'COD_INT': COD_INT,
                'propietarioId': propietarioId,
                'entornoId': entornoId,
                'municipioId': (municipioId != null ? municipioId : 0)

            },
            data: tunel,
            headers: { 'Content-Type': undefined },
        });
    }

    function guardarInventarioPresa(Id, presa, Nombre, COD_INT, municipioId) {

        return $http({
            method: 'put',
            url: serviceUrl + 'presas/put/' + Id,
            params:
            {
                //'strTunel': JSON.stringify(tunel),
                'COD_INT': COD_INT,
                'Nombre': Nombre,
                'municipioId': municipioId
            },
            data: presa,
            headers: { 'Content-Type': undefined },
        });
    }


    function getPresa(idInfraestructura) {
        return $http.get(serviceUrl + "presas/" + idInfraestructura);
    }



    function verInspeccion(idInspeccion) {
        return $http.get(serviceUrl + "inspecciones/" + idInspeccion);
    }


    function getInspeccion(idInspeccion) {
        return $http.get(serviceUrl + "inspeccion/" + idInspeccion);
    }

    function getInspeccionesTunel(idTunel) {
        return $http.get(serviceUrl + "inspeccionesTunel/tunel/" + idTunel);
    }


    function getInspeccionesTunelADIF(idTunelADIF) {
        return $http.get(serviceUrl + "inspeccionesTunelADIF/tunelADIF/" + idTunelADIF);
    }

    function getTunelADIF(idTunelADIF) {
        return $http({
            method: 'GET',
            url: serviceUrl + 'tunelesADIF/' + idTunelADIF
        });
    }

    function getInspeccionesPresa(idPresa) {
        return $http.get(serviceUrl + "inspeccionesPresa/presa/" + idPresa);
    }

    function guardarInspeccion(inspeccion) {
        return $http.put(serviceUrl + 'inspecciones/put/' + inspeccion.Id, inspeccion);
    }

    function getChatBox(pregunta) {
        return $http({
            method: 'post',
            url: serviceUrl + chatboxUrl,
            params: {
                'request': pregunta
            }
        });
    }


    function exportarTunelesADIF(idsTuneles, usuario) {
        return $http({
            method: 'POST',
            url: serviceUrl + 'infraestructuras/tunelesADIF/exportar',
            params: {
                usuario: usuario
            },
            data: {
                IdsTuneles: idsTuneles
            },
            responseType: 'arraybuffer'
        });
    }


    function exportarPatologiasTunelesADIF(idsTuneles, gravedad) {

        return $http({
            method: 'post',
            url: serviceUrl + 'infraestructuras/tunelesADIF/patologias/exportar',
            params: {
                gravedad: gravedad
            },
            data: idsTuneles,
            responseType: 'arraybuffer'
        });
    }




    return {
        getCategorias: getCategorias,
        getInfraestructura: getInfraestructura,
        getCategoria: getCategoria,
        getTiposTunel: getTiposTunel,
        getObstaculos: getObstaculos,
        getNumDireccionesTunel: getNumDireccionesTunel,
        getLongitudTunel: getLongitudTunel,
        getMaterialesTunel: getMaterialesTunel,
        getTipoVia: getTipoVia,
        getCirculacionPermitida: getCirculacionPermitida,
        getTunel: getTunel,
        guardarInventarioTunel: guardarInventarioTunel,
        guardarInventarioPresa: guardarInventarioPresa,
        guardarInspeccion: guardarInspeccion,
        getInspeccion: getInspeccion,
        getDatosGalibos: getDatosGalibos,
        guardarInspeccion: guardarInspeccion,
        getInspeccionesTunel: getInspeccionesTunel,
        getInspeccionesPresa: getInspeccionesPresa,
        verInspeccion: verInspeccion,
        getUltimaInspeccionPorTunel: getUltimaInspeccionPorTunel,
        getDañosPorTipo: getDañosPorTipo,
        getDañosPorGravedad: getDañosPorGravedad,
        getInforme: getInforme,
        getChatBox: getChatBox,
        getDañosPorElemento: getDañosPorElemento,
        getResumenPorSeccion: getResumenPorSeccion,
        getDañosPorGravedadTodosLosTuneles: getDañosPorGravedadTodosLosTuneles,
        getDañosPorGravedadTodosLosTunelesADIF: getDañosPorGravedadTodosLosTunelesADIF,
        getInfraestructuraPorGravedad: getInfraestructuraPorGravedad,
        getListado: getListado,
        getTodasLasInspecciones: getTodasLasInspecciones,
        //getDañosPorSeccion: getDañosPorSeccion
        getPresa: getPresa,
        getTiposPresa: getTiposPresa,
        getformaPlanta: getformaPlanta,
        getMaterialesPresa: getMaterialesPresa,
        getCategoriaPresa: getCategoriaPresa,
        getUsosPresa: getUsosPresa,
        getInfraestructurasADIFCategoria: getInfraestructurasADIFCategoria,
        getInfraestructurasNOADIFCategoria: getInfraestructurasNOADIFCategoria,
        getInspeccionesTunelADIF: getInspeccionesTunelADIF,
        getTunelADIF: getTunelADIF,
        getUltimaInspeccionPorTunelADIF: getUltimaInspeccionPorTunelADIF,
        getDañosADIFPorTipo: getDañosADIFPorTipo,
        getDañosADIFPorGravedad: getDañosADIFPorGravedad,
        getDañosADIFPorElemento: getDañosADIFPorElemento,
        getGravedades: getGravedades,
        getPatologiasTunelesADIF: getPatologiasTunelesADIF,
        getResumenTiposPatologiasTunelesADIF: getResumenTiposPatologiasTunelesADIF,
        getResumenElementosPatologiasTunelesADIF: getResumenElementosPatologiasTunelesADIF,
        getTiposRed: getTiposRed,
        exportarTunelesADIF: exportarTunelesADIF,
        exportarPatologiasTunelesADIF: exportarPatologiasTunelesADIF

    }

}]);

